import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  FormHelperText,
  CircularProgress,
  Popper,
  Paper,
  InputAdornment,
} from "@mui/material";
import {
  MailOutline as MailOutlineIcon,
  ShareLocationRounded as ShareLocationRoundedIcon,
} from "@mui/icons-material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PinIcon from '@mui/icons-material/Pin';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import EditIcon from "@mui/icons-material/Edit";
import * as Yup from "yup";
import Tooltip from "@mui/material/Tooltip";
import useAxios from "../../../../api/useAxios";
import { useLocation } from "react-router";
import { useFormik } from "formik";
import Context from "../Context";
import { Stack } from "@mui/system";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function VotingDetails({ setput }) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const filterOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    const startsWithInput = [];
    const containsInput = [];

    options.forEach((option) => {
      const optionLower = option.toLowerCase();
      if (optionLower.startsWith(inputValueLower)) {
        startsWithInput.push(option);
      } else if (optionLower.includes(inputValueLower)) {
        containsInput.push(option);
      }
    });

    return [...startsWithInput, ...containsInput];
  };
  const [mpConstituency, setMP] = useState({
    code: 4,
    District: "",
    ParlimentConstituency: [],
  });
  var [mlaConstituency, setMLA] = useState([]);
  const [pincodeNumData, setPincodeNumData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [district, setDistrict] = useState([]);
  const [adDistrict, setAdDistrict] = useState([]);
  const [PincodeData, setPincodeData] = useState([]);
  const [PostOfficeData, setPostOfficeData] = useState([]);
  const [newPincode, setPincode] = useState([]);
  const [comdata, setComdata] = useState([]);
  const [pinLoad, setpinLoad] = useState(false);
  const [data, setData] = useState(false);
  const [pincodeValue, setPincodeValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [stateArray, setStateArray] = useState([]);
  console.log(stateValue)
  const [open, setOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClickOpen = async (vdetails, mpget, mlaget, pinget) => {
    setOpen(true);
    await mlaSelection(vdetails);
    await areaPincode(vdetails);
    formik.setFieldValue("votingDistrict", vdetails);
    formik.setFieldValue("mpConstituency", mpget);
    formik.setFieldValue("mlaConstituency", mlaget);
    formik.setFieldValue("pincode", pinget);
  };
  const handleClose = () => {
    formik.handleReset("");
    setOpen(false);
  };
  const axiosData = useAxios();
  const location = useLocation();
  const formik = useFormik({
    initialValues: {
      votingDistrict: "",
      mpConstituency: "",
      mlaConstituency: "",
      pincode: "",
      area_name: "",
      pincode_num: "",
    },
    validationSchema: Yup.object({
      votingDistrict: Yup.string().required("Select District"),
      mpConstituency: Yup.string().required("Select MP Constituency"),
      mlaConstituency: Yup.string().required("Select MLA Constituency"),
      pincode: Yup.string().required("Pincode is Required"),
    }),
    onSubmit: async (values) => {
      let mla = values.mlaConstituency;
      let mla2 = mla.replace(/[-\s.,]+/g, "");
      values.mlaConstituency = mla2;
      if (pincodeNumData) {
        values.pincode_num = pincodeNumData[0];
        values.area_name = pincodeNumData[1];
      }
      setIsSubmitting(true);
      await axiosData.put(`seeker/email/${location.state}`, values);
      setput(true);
      setIsSubmitting(false);
      formik.handleReset("");
      handleClose();
    },
  });
  const mlaSelection = (value) => {
    formik.setFieldValue("mpConstituency", "");
    formik.setFieldValue("mlaConstituency", "");
    const data = district.map((element) => {
      if (element.District === value) {
        setMLA([]);
        setMP({ ...element });
      }
    });
    // if(data){
    //       console.log(mpConstituency,mlaConstituency,data)
    //          mpConstituency.ParlimentConstituency.map((element, index) => {
    //          mlaConstituency = [];
    //             mpConstituency[element].map((element) => {
    //             mlaConstituency.push(element);
    //             console.log(mpConstituency,mlaConstituency,element)
    //             setMLA([...mlaConstituency]);
    //             });
    //         })
    // }
  };
  const areaPincode = async (values) => {
    setAdDistrict(values);

    try {
      setpinLoad(true);
      const getOneAxiospin = await axiosData.get(
        `/distritarea/getArea/${values}`
      );
      setpinLoad(false);
      const datapin = getOneAxiospin.data;
      if (datapin) {
        const getpin = datapin.map((i) => {
          return i.Pincode;
        });
        const getpost = datapin.map((i) => {
          return i.Post_Office;
        });
        const getpost1 = getpost[0];
        const result = getpin[0].reduce(
          (accumulator, currentPincode, index) => {
            return accumulator.concat(`${currentPincode}/${getpost1[index]}`);
          },
          []
        );
        const getPostFinal = result.map((i) => {
          return i;
        });
        setPincodeData(getpin[0]);
        setPostOfficeData(getpost[0]);
        setPincode(datapin);
        setComdata([...getPostFinal]);
      }

      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
  const vodingDistrict = async () => {
    try {
      const getOneAxios = await axiosData.get(`/district`);
      const data = getOneAxios.data;
      if (data) {
        const getDistrict = data.map((i) => {
          return i.District;
        });
        getDistrict.sort();
        setDistrictData(getDistrict);
        setDistrict(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
   const votingStateGet = async (state) => {
    try {
      const getOneAxios = await axiosData.get(`/state/${encodeURIComponent(state)}`);
      const data = getOneAxios.data;
      if (data) {
        data.districts.sort();
       setDistrictData(data.districts.sort());
       //setDistrict(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };
  useEffect(() => {
    if (pincodeValue) {
      const parts = pincodeValue.split("/");
      if (parts.length === 2) {
        setPincodeNumData(parts);
      }
    }
  }, [formik.values.pincode]);

  useEffect(() => {
    vodingDistrict();
    //votingStateGet(stateValue)
  }, [stateValue]);
  useEffect(() => {
    if (formik.values.mpConstituency) {
      const mlaList = mpConstituency[formik.values.mpConstituency] || [];
      setMLA(mlaList);
    }
  }, [formik.values.mpConstituency]);

  return (
    <Context.Consumer>
      {(context) => {
        let votedetails = "";
        let mp = "";
        let mla = "";
        let pin = "";
        if (context.profile.votingDistrict) {
  //votingStateGet(context.profile.state)
          setStateValue(context.profile.state)
          votedetails = context.profile.votingDistrict;
          mp = context.profile.mpConstituency;
          mla = context.profile.mlaConstituency;
          pin = context.profile.pincode;
        }

        return (
          <div>
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              aria-describedby="alert-dialog-slide-description"
              sx={{ "& .MuiPaper-root": { width: "500px" } }}
            >
              <form onSubmit={formik.handleSubmit}>
                <DialogTitle>
                  <Typography variant="h5">
                    <b>Voting Details</b>
                  </Typography>
                  <Grid item xs={12} sm={12} md={8} square>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        mt: 1,
                      }}
                      color="text.secondary"
                    >
                      Mention your voting details.
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ p: 3 }}>
                        {/* <FormControl className="Educationfieldsize"> */}
                        <Autocomplete
                          className="Educationfieldsize"
                          disableClearable={
                            formik.values.votingDistrict ? false : true
                          }
                          filterOptions={filterOptions}
                          name="votingDistrict"
                          id="votingDistrict"
                          value={formik.values.votingDistrict}
                          onChange={(event, value) => {
                            formik.setFieldValue("votingDistrict", value);
                            formik.setFieldValue("mpConstituency", "");
                            formik.setFieldValue("mlaConstituency", "");
                            mlaSelection(value);
                            areaPincode(value);
                            formik.setFieldValue("pincode", "");
                          }}
                          onBlur={formik.handleBlur}
                          options={districtData}
                          getOptionLabel={(option) => option}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={"District"}
                              // onClick={() => params.inputProps.onInputClick()}
                              InputLabelProps={{
                                style: { marginLeft: "7px" },
                              }}
                            />
                          )}
                          onOpen={(event) => event.preventDefault()}
                          PopperComponent={({ children, ...popperProps }) => (
                            <Popper
                              {...popperProps}
                              placement="bottom-start"
                              modifiers={{
                                flip: {
                                  enabled: false,
                                },
                                preventOverflow: {
                                  enabled: true,
                                  boundariesElement: "scrollParent",
                                },
                              }}
                              PopperProps={{
                                placement: "bottom-start", // Placement set to "bottom-start"
                              }}
                            >
                              <Paper>{children}</Paper>
                            </Popper>
                          )}
                          ListboxProps={{
                            style: { maxHeight: "180px", overflowY: "auto" },
                          }}
                        />
                        {formik.touched.votingDistrict &&
                        formik.errors.votingDistrict &&
                        !formik.values.votingDistrict ? (
                          <div style={{ color: "red", fontSize: "13px" }}>
                            {formik.errors.votingDistrict}
                          </div>
                        ) : null}
                        <Tooltip
                          title={
                            formik.values.votingDistrict
                              ? null
                              : "Select District"
                          }
                          arrow
                        >
                          <FormControl
                            disabled={
                              formik.values.votingDistrict ? false : true
                            }
                            sx={{ mt: 2 }}
                            className="Educationfieldsize"
                            fullWidth
                            required
                          >
                            <InputLabel
                              sx={{ ml: 1 }}
                              id="demo-simple-select-label"
                            >
                              {"MP Constituency"}
                            </InputLabel>
                            <Select
                              name="mpConstituency"
                              labelId="demo-simple-select-label"
                              id="mpConstituency"
                              label="MP Constituency"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.mpConstituency}
                            >
                              {mpConstituency.ParlimentConstituency.map(
                                (element, index) => {
                                  return (
                                    <MenuItem
                                      key={index}
                                      value={element}
                                      onClick={() => {
                                        mlaConstituency = [];
                                        mpConstituency[element].map(
                                          (element) => {
                                            mlaConstituency.push(element);
                                            setMLA([...mlaConstituency]);
                                            formik.setFieldValue(
                                              "mlaConstituency",
                                              ""
                                            );
                                          }
                                        );
                                      }}
                                    >
                                      {element}
                                    </MenuItem>
                                  );
                                }
                              )}
                            </Select>
                            {formik.touched.mpConstituency &&
                            formik.errors.mpConstituency ? (
                              <div style={{ color: "red", fontSize: "13px" }}>
                                {formik.errors.mpConstituency}
                              </div>
                            ) : null}
                          </FormControl>
                        </Tooltip>
                        <Tooltip
                          title={
                            formik.values.mpConstituency
                              ? null
                              : "Select MP Constituency"
                          }
                          arrow
                        >
                          <FormControl
                            disabled={
                              formik.values.mpConstituency ? false : true
                            }
                            sx={{ mt: 2 }}
                            //   className="Educationfieldsize"
                            required
                            fullWidth
                          >
                            <InputLabel
                              sx={{ ml: 1 }}
                              id="demo-simple-select-label"
                            >
                              {"MLA Constituency"}
                            </InputLabel>
                            <Select
                              name="mlaConstituency"
                              labelId="demo-simple-select-label"
                              id="mlaConstituency"
                              label="mlaConstituency"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.mlaConstituency}
                            >
                              {mlaConstituency.map((element, index) => {
                                return (
                                  <MenuItem key={index} value={element}>
                                    {element}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            {formik.touched.mlaConstituency &&
                            formik.errors.mlaConstituency ? (
                              <div style={{ color: "red", fontSize: "13px" }}>
                                {formik.errors.mlaConstituency}
                              </div>
                            ) : null}
                          </FormControl>
                        </Tooltip>
                        <Tooltip
                          title={
                            formik.values.votingDistrict
                              ? null
                              : "Select District"
                          }
                          arrow
                        >
                          <FormControl sx={{ mt: 3, mb: 1 }} fullWidth required>
                            <Autocomplete
                              disabled={
                                formik.values.votingDistrict && !pinLoad
                                  ? false
                                  : true
                              }
                              disableClearable={
                                formik.values.pincode ? false : true
                              }
                              filterOptions={filterOptions}
                              id="pincode"
                              name="pincode"
                              options={comdata}
                              onBlur={formik.handleBlur}
                              onChange={(event, value) => {
                                formik.setFieldValue("pincode", value);
                                setPincodeValue(value);
                              }}
                              value={formik.values.pincode}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  id="pincode"
                                  label={"Pincode"}
                                  name="pincode"
                                  InputLabelProps={{
                                    style: {
                                      color: "black",
                                      marginLeft: "7px",
                                    },
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {pinLoad ? (
                                          <CircularProgress
                                            // size={24}
                                            style={{
                                              width: "1.7rem",
                                              height: "1.7rem",
                                              color:
                                                formik.errors.pincode ===
                                                  undefined ||
                                                formik.touched.pincode ===
                                                  undefined
                                                  ? "#1976d5"
                                                  : formik.errors.pincode !==
                                                      undefined &&
                                                    formik.touched.pincode ===
                                                      true
                                                  ? "#de6363"
                                                  : "#666666",
                                            }}
                                          />
                                        ) : (
                                          <ShareLocationRoundedIcon
                                            sx={{
                                              color:
                                                formik.errors.pincode ===
                                                  undefined ||
                                                formik.touched.pincode ===
                                                  undefined
                                                  ? "#1976d5"
                                                  : formik.errors.pincode !==
                                                      undefined &&
                                                    formik.touched.pincode ===
                                                      true
                                                  ? "#de6363"
                                                  : "#666666",
                                            }}
                                          />
                                        )}{" "}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                              onOpen={(event) => event.preventDefault()}
                              PopperComponent={({
                                children,
                                ...popperProps
                              }) => (
                                <Popper
                                  {...popperProps}
                                  placement="bottom-start"
                                  modifiers={{
                                    flip: {
                                      enabled: false,
                                    },
                                    preventOverflow: {
                                      enabled: true,
                                      boundariesElement: "scrollParent",
                                    },
                                  }}
                                  PopperProps={{
                                    placement: "bottom-start", // Placement set to "bottom-start"
                                  }}
                                >
                                  <Paper>{children}</Paper>
                                </Popper>
                              )}
                              ListboxProps={{
                                style: {
                                  maxHeight: "180px",
                                  overflowY: "auto",
                                },
                              }}
                            />
                            {formik.touched.pincode && formik.errors.pincode ? (
                              <div style={{ color: "red", fontSize: "13px" }}>
                                {formik.errors.pincode}
                              </div>
                            ) : null}
                          </FormControl>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Grid>
                </DialogTitle>

                <DialogActions sx={{ mr: 2, mt: -6, mb: 1 }}>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={
                      formik.isValid && formik.dirty && isSubmitting === false
                        ? false
                        : true
                    }
                    variant="contained"
                    type="submit"
                  >
                    Update
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        style={{
                          color: "#ffffff",

                          marginLeft: 12,
                        }}
                      />
                    )}
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
            <Grid xs={12} md={12} lg={12}>
              <Box
                id="Education"
                sx={{ fontSize: "18px", textTransform: "uppercase" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <b style={{ color: "rgb(16 143 178)" }}>Voting Details</b>
                  <Button
                    sx={{ ml: -1.5, mt: -1 }}
                    onClick={() => handleClickOpen(votedetails, mp, mla, pin)}
                  >
                    <Tooltip title="Edit" arrow>
                      <EditIcon />
                    </Tooltip>
                  </Button>
                </Box>
              </Box>
              <hr />
              {votedetails !== "" ? (
                // <>
                //   {" "}
                //   <Typography
                //     sx={{ fontWeight: 600 }}
                //     variant="h5"
                //     component="div"
                //     color="text.secondary"
                //   >
                //     District :{votedetails}
                //   </Typography>
                //   <Typography sx={{ fontWeight: 600 }} color="text.secondary">
                //     {mp}
                //   </Typography>
                //   <Typography sx={{ fontWeight: 600 }} color="text.secondary">
                //     {mla}
                //   </Typography>
                //   <Typography sx={{ fontWeight: 600 }} color="text.secondary">
                //     {pin}
                //   </Typography>
                // </>
                <>
  <Box >
<Grid container spacing={2}>
  {/* First Column */}
  <Grid item xs={12} md={6}>
    <Stack spacing={2}>
      {/* District Section */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <LocationOnIcon 
          sx={{ 
            color: 'primary.main', 
            mr: 1.5, 
            mt: 0.5,
            fontSize: 20
          }} 
        />
        <Box>
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ fontWeight: 500, textTransform: 'uppercase' }}
          >
            District
          </Typography>
          <Typography 
            sx={{ 
              fontWeight: 600,
              color: 'text.primary',
              fontSize: '1.1rem'
            }}
          >
            {votedetails}
          </Typography>
        </Box>
      </Box>

      {/* MP Section */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <PersonIcon 
          sx={{ 
            color: 'success.main', 
            mr: 1.5, 
            mt: 0.5,
            fontSize: 20
          }} 
        />
        <Box>
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ fontWeight: 500, textTransform: 'uppercase' }}
          >
            Member of Parliament
          </Typography>
          <Typography 
            sx={{ 
              fontWeight: 600,
              color: 'text.primary'
            }}
          >
            {mp}
          </Typography>
        </Box>
      </Box>
    </Stack>
  </Grid>

  {/* Second Column */}
  <Grid item xs={12} md={6}>
    <Stack spacing={2}>
      {/* PIN Code Section */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <PinIcon 
          sx={{ 
            color: 'error.main', 
            mr: 1.5, 
            mt: 0.5,
            fontSize: 20
          }} 
        />
        <Box>
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ fontWeight: 500, textTransform: 'uppercase' }}
          >
            PIN Code
          </Typography>
          <Typography 
            sx={{ 
              fontWeight: 600,
              color: 'text.primary',
              fontFamily: 'monospace',
              fontSize: '1.1rem'
            }}
          >
            {pin}
          </Typography>
        </Box>
      </Box>

      {/* MLA Section */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <AccountBalanceIcon 
          sx={{ 
            color: 'warning.main', 
            mr: 1.5, 
            mt: 0.5,
            fontSize: 20
          }} 
        />
        <Box>
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ fontWeight: 500, textTransform: 'uppercase' }}
          >
            Member of Legislative Assembly
          </Typography>
          <Typography 
            sx={{ 
              fontWeight: 600,
              color: 'text.primary'
            }}
          >
            {mla}
          </Typography>
        </Box>
      </Box>
    </Stack>
  </Grid>
</Grid>
  </Box>
</>
              ) : (
                <Typography
                  sx={{
                    fontWeight: 600,
                    textTransform: "uppercase",
                    fontSize: "14px",
                    mt: 1,
                  }}
                  color="text.secondary"
                >
                  Mention your Voting details.
                </Typography>
              )}
            </Grid>
          </div>
        );
      }}
    </Context.Consumer>
  );
}

export default VotingDetails;
